module.exports = __webpack_public_path__ + "img/tick.b5bb27ca.svg";